import './index.css';
import { ToastProvider, TooltipProvider } from '@convometry/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createQueryClient } from './lib/query.js';
import { createAppRouter } from './app/router.js';
import { refreshSession } from './lib/api.js';

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

// Touch the Better Auth session once at start so its sliding expiry refreshes.
void refreshSession();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={200}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
